'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteCreate', ['$uibModal', 'NotesQueryManagementService', 'Notes', '$rootScope', 'toastr', function($uibModal, NotesQueryManagementService, Notes, $rootScope, toastr) {
    return {
      restrict: 'A',
      scope: {
        managementId: '@'
      },
      bindToController: {
        note: '=?'
      },
      templateUrl: 'views/directives/notes/saNoteCreate.html',
      require: '?^saNote',
      controllerAs: 'NoteCtrl',
      controller: ['$scope', 'Session', 'NotesStore', 'TimeService', 'SAErrorHandler', 'NotesOverlayContextService', 'NoteMessagesService', 'saNoteMessageParseDelay', 'MediaStore', 'saMediaLinkMatchers', '$q', '$timeout', '$rootScope',
        function($scope, Session, NotesStore, TimeService, SAErrorHandler, NotesOverlayContextService, NoteMessagesService, saNoteMessageParseDelay, MediaStore, saMediaLinkMatchers, $q, $timeout, $rootScope) {
          var vm = this;

          // If no note, create one
          if (!vm.note) {
            vm.note = Notes.initNew();
          }

          vm.stagedMedia = [];
          vm.thumbnailRecords = [];
          generateThumbnailRecords();


          vm.setMediaData = function(serviceType, blobs) {
            lodash.each(blobs, function(blob) {
              vm.stagedMedia.push({
                isLink: (serviceType in saMediaLinkMatchers),
                service_type: serviceType,
                external_id: blob.external_id,
                tags: [],
                data: blob
              });
            });

            console.log('setMediaData', vm.stagedMedia);

            $timeout(generateThumbnailRecords, 0);
          };

          vm.uploadingMedia = false;
          vm.beginMediaUpload = function() {
            vm.uploadingMedia = true;
          };

          vm.endMediaUpload = function() {
            vm.uploadingMedia = false;
          };

          vm.removeMedia = function(index) {
            var toRemove = vm.thumbnailRecords[index];

            // Remove from the correct array
            if (toRemove.preexisting) {
              vm.note._media.splice(toRemove.idx, 1);
            } else {
              vm.stagedMedia.splice(toRemove.idx, 1);
            }


            // Remove the ids from the object as well
            var removedId = toRemove.media.id;
            var indexToDelete = lodash.findIndex(vm.note.media_ids || [], removedId);

            if (indexToDelete > -1) {
              vm.note.media_ids.splice(indexToDelete, 1);

              Notes.update({id: vm.note.id, media_ids: vm.note.media_ids})
                .then(function(response) {
                  console.log('Successfully Removed Media IDs');
                }, function(response) {
                  console.log('Failed to Remove Media IDs');
                });
            }

            generateThumbnailRecords();
          };

          function assembleThumbnails() {
            lodash.each(vm.note._media, function(m, index) {
              vm.thumbnailRecords.push({
                idx: index,
                preexisting: true,
                media: m
              });
            });

            lodash.each(vm.stagedMedia, function(m, index) {
              vm.thumbnailRecords.push({
                idx: index,
                preexisting: false,
                media: m
              });
            });
          }

          function generateThumbnailRecords() {
            vm.thumbnailRecords = [];
            if (!vm.note._media && (vm.note.media_ids && vm.note.media_ids.length > 0)) {
              MediaStore.getMediaByIds(vm.note.media_ids)
                .then(function(mediaObjs) {
                  vm.note._media = mediaObjs;
                  assembleThumbnails();
                }, function(err) {
                  // Nothing
                });
            } else {
              assembleThumbnails();
            }
          }


          vm.getMode = function() {
            return $scope.state.mode;
          };

          vm.setNotePermission = function(permId) {
            vm.note.permission = permId;
          };

          vm.diffMediaLinkObjects = function() {
            var links = NoteMessagesService.findMediaLinks(vm.note.message);

            // If the user deletes a link from the message, we want to remove that
            // link's corresponding media object from the staged media array
            vm.stagedMedia = lodash(vm.stagedMedia).filter(function(media) {
              media._hash = media.service_type + ":" + media.external_id;
              return lodash.every(links, function(link) {
                return link.hash !== media._hash;
              }) && media.isLink || !media.isLink;
            }).value();

            var addIds = function(pLinks) {
              // Add new linked media in the most grotesque way ever conceived
              console.log("Adding", pLinks);
              lodash(pLinks).filter(function(link) {
                return lodash.every(vm.stagedMedia, function(media) {
                  return link.hash != media._hash;
                });
              }).each(function(link) {
                console.log("Pushing ", link.service_type, ", ", link.external_id);
                vm.setMediaData(
                  link.service_type,
                  [{
                    external_id: link.external_id,
                    title: '(Unnamed Media)'
                  }]);
              });
            };

            var deferred = $q.defer();

            if (vm.note.media_ids && vm.note.media_ids.length > 0) {
              // Next, kick out media objects that are already in the media IDs

              MediaStore.getMediaByIds(vm.note.media_ids)
                .then(function(mediaObjects) {
                  lodash.each(mediaObjects, function(e) {
                    e._hash = e.service_type + ":" + e.external_id;
                  });

                  links = lodash(links).filter(function(link) {
                    // Keep a link only if ALL of the existing media objects'
                    // hashes do not match its hash.
                    return lodash.every(mediaObjects, function(media) {
                      return link.hash != media._hash;
                    });
                  }).value();

                  addIds(links);
                  deferred.resolve(links);
              }, deferred.reject);
            } else {
              addIds(links);
              deferred.resolve(links);
            }


            return deferred.promise;
          };

          vm._diffMediaLinkObjectsDebounced = lodash.debounce(function(htmlMessage) {
            console.log(vm.note.message);
            vm.diffMediaLinkObjects();
          }, 1000);

          vm.setMessage = lodash.throttle(function(htmlMessage) {
            vm.note.message = NoteMessagesService.toString(htmlMessage);
            vm._diffMediaLinkObjectsDebounced(htmlMessage);

            if (htmlMessage == '') {
              $rootScope.$broadcast('saNoteCreate:noteEmpty');
            } else {
              $rootScope.$broadcast('saNoteCreate:noteInProgress');
            }
          }, saNoteMessageParseDelay);

          // Submit note
          vm.submit = function() {
            if (!$scope.state.isSubmitting) {
              $scope.state.isSubmitting = true;

              vm.diffMediaLinkObjects()
                .then(function() {
                  if (!vm.uploadingMedia) {
                    // Get note permission
                    var permission = vm.note.permission;
                    // If we didn't have a note, try to get the parent's note's permission. This also might not work
                    // but this shold work for now.
                    // SATODO: Do this in a way that will always work, even if there is no parent note
                    if (lodash.isUndefined(permission) || lodash.isNull(permission) || !(typeof(permission) === 'number')) {
                      permission = $scope.parentCtrl && $scope.parentCtrl.note && $scope.parentCtrl.note.permission;
                    }

                    // All staged media must have a permission. For now, it will match the permission of the note
                    lodash.each(vm.stagedMedia, function(sm) {
                      sm.permission = permission;
                    });


                    var data = {
                      organization_id: Session.getCurrentOrgId(),
                      permission: permission,
                      parent_id: vm.note.parent_id || ($scope.parentCtrl && $scope.parentCtrl.note && $scope.parentCtrl.note.id) || null,
                      message: vm.note.message,
                      media: vm.stagedMedia || null,
                      media_ids: vm.note.media_ids || [],
                      id: vm.note.id || null
                    };

                    if (($scope.state.editedRelation && $scope.state.editMode) || (!$scope.state.replyMode && !$scope.state.editMode)) {
                      data.relation = lodash.omit(lodash.first(vm.note.notes_relations), ['range_twix', 'id', 'created_at', 'updated_at', 'inactivated_at', 'inactivated_by', 'note_id', 'active']);
                    }

                    if (vm.note.id) {
                      NotesStore.updateNote(data)
                        .then(function() {
                          $scope.$emit('saNoteCreate:updateSuccessful');
                          $scope.state.isSubmitting = false;
                        }, function() {
                          // TODO -- Let the user know that there was an error
                        });
                    } else {
                      NotesStore.createNote(data).then(function(createdNote){
                        console.log('createdNote: ', createdNote);
                        vm.stagedMedia = [];
                        vm.thumbnailRecords = [];
                        $rootScope.$broadcast('saNoteCreate:noteEmpty');
                        $scope.$broadcast('saNoteCreate:createSuccessful');

                        if (!$scope.state.editMode && !$scope.state.replyMode) {
                          $scope.setCompact();
                        }

                        if (!$scope.state.replyMode && !$scope.state.editMode) {
                          $scope.NoteCtrl.note.notes_relations = [$scope.generateRelationForQuery()];
                        }

                        $scope.state.isSubmitting = false;
                      }, function(response) {
                        SAErrorHandler.processError(response);
                        $scope.state.isSubmitting = false;
                      });
                    }

                  } else {
                    $scope.state.isSubmitting = false;
                    toastr.error('Please wait for your media to finish uploading.', 'Error');
                  }
                }, function(x) {
                  $scope.state.isSubmitting = false;
                  Rollbar.error('DiffMediaLinkObjects failed', x);
                });
            }
          };

          $scope.$on('updatedSessionMe', function(isLoggedIn) {
            vm.note.user = Session.me
          });

          $scope.activateLightbox = function(currentMediaIndex) {
            var modalInstance = $uibModal.open({
              size: 'md',
              templateUrl: 'views/lightbox.html',
              controller: 'Lightbox',
              resolve: {
                params: function() {
                  return {
                    media: vm.stagedMedia,
                    currentMediaIndex: currentMediaIndex
                  }
                }
              }
            });
          };


          vm.updateRelation = function(data) {
            $scope.state.editedRelation = true;
            var rel = vm.note.notes_relations[0];

            rel.start_date = data.start_date;
            rel.end_date = data.end_date;

            $scope.$broadcast('sa:saNoteRelationView:update');
          }
        }],
      link: function(scope, element, attrs, parentCtrl) {
        // If parentCtrl is non-null, then this is a reply
        scope.parentCtrl = parentCtrl;
        scope.state = {
          mode: attrs.mode,
          replyMode: attrs.mode && attrs.mode === 'reply',
          editMode: attrs.mode && attrs.mode === 'edit',
          managementId: scope.managementId,
          expanded: false,
          editedRelation: false
        };

        scope.setCompact = function() {
          $(element).addClass('sa-note-create-compact');
          scope.state.expanded = false;
          scope.$emit('sa-note-create-expanded');
        };

        scope.focusElement = function() {
          if (!scope.state.expanded) {
            $(element).removeClass('sa-note-create-compact');
            $(element).find('.sa-note-focal div').focus();

            scope.$emit('sa-note-create-expanded');
          }
        };

        scope.$on('focus-sa-note-create', function() {
          scope.focusElement();
        });

        if (scope.state.replyMode) {
          $(element).find('.sa-note-create').addClass('sa-note-create-is-reply');
        } else if (scope.state.editMode) {
          $(element).find('.sa-note-create').addClass('sa-note-create-is-edit');
        }

        scope.generateRelationForQuery = function() {
          // Build the relation for the new Note
          var query = scope.state.currentState.query;
          var relation = {
            active: true
          };

          if (query.obj && query.obj_id) {
            relation = lodash.merge(relation, {
              obj: query.obj,
              obj_id: query.obj_id
            });
          }

          if (query.dates && query.dates.start && query.dates.end) {
            relation = lodash.merge(relation, {
              start_date: query.dates.start.toISOString(),
              end_date: query.dates.end.toISOString()
            });
          }

          // if we have an Obj but no start_date... set start_date to effectively created_at
          if (!lodash.has(relation, 'start_date') && lodash.has(relation, 'obj') && relation.obj !== 'WorkPeriod') {
            relation = lodash.merge(relation, {
              start_date: moment.utc().toISOString()
            });

            if (relation.obj === 'User') {
              relation.end_date = relation.start_date;
            }
          }

          return Notes.initNotesRelation(relation);
        }


        function updateCurrentQuery() {
          if (!scope.state.currentState) {
            scope.state.currentState = NotesQueryManagementService.getIdState(scope.state.managementId);
          } else {
            var temp = NotesQueryManagementService.getIdState(scope.state.managementId);
            scope.state.currentState.query = temp.query;
          }

          if (!scope.state.replyMode && !scope.state.editMode) {
            scope.NoteCtrl.note.notes_relations = [scope.generateRelationForQuery()];
            scope.$broadcast('sa:saNoteRelationView:update');
          }
        }

        function subscribeToUpdates() {
          // subscribe this directive to updates that have 'queryUpdate' key
          scope.state.updateChannel = scope.state.currentState.
            subject.filter(function(obj) {
              return obj.queryUpdate;
            }).
            subscribe(function(obj) {
              // when we receive an update, update scope.state.currentState.query, then re-render
              updateCurrentQuery();
          });
        }


        if (scope.state.managementId) {
          // initialize query and updates if we have a managementId (we're not in editMode or replyMode)
          updateCurrentQuery();

          subscribeToUpdates();

          scope.$on('$destroy', function() {
            scope.state.updateChannel.dispose();
            $rootScope.$broadcast('saNoteCreate:noteEmpty');
          });
        }
      }
    }
  }]);
